import React from 'react';
import { NavLink, Outlet } from 'react-router-dom';

export const PromotionsTab = () => {
  return (
    <>
      <div className="d-flex flex-column">
        <div className={'d-flex w-full'}>
          <ul className="nav nav-pills mb-4 d-inline-flex align-self-start">
            <li className="nav-item">
              <NavLink
                to="/marketing/promotions/commission"
                className="nav-link text-decoration-none"
              >
                Управление комиссией
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                to="/marketing/promotions/bonus"
                className="nav-link text-decoration-none"
              >
                Управление бонусами
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                to="/marketing/promotions/burn-bonuses-logs"
                className="nav-link text-decoration-none"
              >
                История сгорания бонусов
              </NavLink>
            </li>
          </ul>
        </div>
        <Outlet />
      </div>
    </>
  );
};
